export const STATUS = {
    PENDING: "pending",
    AVAILABLE: "available",
} as const;